var _path, _path2, _g, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgAd = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M0 85.331h512v341.337H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M0 85.331h170.663v341.337H0z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#d80027"
}, /*#__PURE__*/React.createElement("path", {
  d: "M341.337 85.331H512v341.337H341.337zM256 315.356v-59.362h44.522v22.261c0 3.868-7.421 18.038-25.735 29.682-6.938 4.411-14.118 5.829-18.787 7.419z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M211.478 211.473H256v44.522h-44.522z"
}))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M278.261 196.632c0-8.196-6.645-14.84-14.84-14.84-2.707 0-5.236.736-7.421 2.001a14.749 14.749 0 00-7.421-2.001c-8.195 0-14.84 6.644-14.84 14.84h-37.101v74.202c0 27.624 21.938 43.599 39.14 51.88a14.75 14.75 0 00-2.039 7.483c0 8.196 6.645 14.84 14.84 14.84 2.707 0 5.236-.736 7.421-2.001a14.749 14.749 0 007.421 2.001c8.195 0 14.84-6.644 14.84-14.84 0-2.733-.751-5.284-2.04-7.483 17.203-8.281 39.141-24.257 39.141-51.88v-74.202h-37.101zm14.84 74.203c0 3.868 0 15.635-18.314 27.279-6.936 4.411-14.118 7.27-18.787 8.861-4.669-1.591-11.849-4.45-18.787-8.861-18.314-11.644-18.314-23.411-18.314-27.278v-51.941h74.203v51.941h-.001z",
  fill: "#ff9811"
})));

export default SvgAd;